import ServerInstance from "./server.api";

class UserEndpoint extends ServerInstance {

    async getUser() {
        try {
            const response = await this.get("user");
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async updateUser(data) {
        try {
            const response = await this.patch("user", data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default UserEndpoint;